export default {
  root: {
    class: [
      // Flexbox
      'inline-flex items-center gap-2',

      // Spacing
      'px-2 py-1',

      // Shape
      'rounded-full',

      // Colors
      'text-gray-600 dark:text-white/70',
      'bg-gray-200 dark:bg-surface-700'
    ]
  },
  label: {
    class: 'leading-none'
  },
  icon: {
    class: 'leading-none mr-2'
  },
  image: {
    class: ['w-9 h-9 -ml-3 mr-2', 'rounded-full']
  },
  removeIcon: {
    class: [
      // Shape
      'rounded-md leading-none',

      // Size
      'size-3',

      // Transition
      'transition duration-200 ease-in-out',

      // Misc
      'cursor-pointer'
    ]
  }
}
